var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"bg-surface-variant"},[_c('v-row',{staticClass:"lotto-border",attrs:{"no-gutters":""}},[_c('v-col',[_c('MobileSection'),_c('MobileDT')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }